export default __webpack_public_path__ + "static/media/back-modal-black.eb8d76b6.svg";